import { useState } from "react";
import { Loader2, RotateCcw, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { timeAgo } from "@/lib/fmt";
import { Button } from "@/components/ui/button";

const STAGE = { queued: "Waiting to start", fetching_pages: "Opening your pages", reading: "Reading the invoice", saving: "Saving what was read", waiting_retry: "Retrying shortly" };

export function InvoiceProcessing({ inv, onChanged }) {
  const [busy, setBusy] = useState(false);
  const p = inv.processing || {};
  if (inv.status !== "extracting") {
    return <div className="card-surface p-8 text-center" data-testid="invoice-extracting"><Loader2 className="h-6 w-6 animate-spin mx-auto mb-2" /><div className="font-medium">Updating…</div></div>;
  }
  const retry = async () => {
    setBusy(true);
    try { await api.post(`/inv/invoices/${inv.id}/retry`); toast.success("Reading again"); await onChanged(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="card-surface p-8 text-center" data-testid="invoice-extracting">
      {p.stale ? <AlertTriangle className="h-6 w-6 mx-auto mb-2 text-amber-600" /> : <Loader2 className="h-6 w-6 animate-spin mx-auto mb-2" />}
      <div className="font-medium" data-testid="invoice-processing-title">{p.stale ? "Reading is taking longer than expected" : "Reading your invoice…"}</div>
      <div className="text-sm text-stone-600 mt-1" data-testid="invoice-processing-stage">
        {STAGE[p.stage] || "Processing"}{p.attempt > 0 && ` · attempt ${p.attempt} of ${p.max_attempts}`}{p.last_update_at && ` · last update ${timeAgo(p.last_update_at)}`}
      </div>
      {p.stage === "waiting_retry" && p.last_error && <div className="text-xs text-stone-500 mt-1" data-testid="invoice-processing-last-error">{p.last_error}</div>}
      {p.stale ? (
        <div className="mt-3 flex flex-col items-center gap-2">
          <div className="text-sm text-stone-500">The reading job stopped responding. Your pages are saved, so nothing was lost.</div>
          {inv.perms?.includes("edit") && <Button className="h-9" disabled={busy} onClick={retry} data-testid="invoice-processing-retry"><RotateCcw className="h-4 w-4 mr-1" />Read it again</Button>}
        </div>
      ) : <div className="text-sm text-stone-500 mt-1">Usually 20–60 seconds. You can leave this screen. The pages are saved.</div>}
    </div>
  );
}
